module.exports = __webpack_public_path__ + "/login_ui/img/logo-white-c80b86e351fd54e19ea1e75a8ea14a3d.svg";